import React from 'react';

import { LobbyFrame } from '../../../lobby';

export const SidebarLobbySection: React.FC = () => {
  return (
    <div className="side-menu-new-content">
      <div className="side-menu-new-content-inner">
        <LobbyFrame />
      </div>
    </div>
  );
};
